import { render, staticRenderFns } from "./DraftGoldBatch.vue?vue&type=template&id=c6795192&"
import script from "./DraftGoldBatch.vue?vue&type=script&lang=js&"
export * from "./DraftGoldBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports